import React from 'react';
import {
  ToggleButtonGroup,
  ToggleButton,
  Tooltip
} from '@mui/material';
import { GridView, ViewList } from '@mui/icons-material';

/**
 * Toggle button group for switching between card and list view
 */
const ViewToggle = ({ mode, onToggle }) => {
  const handleChange = (event, newMode) => {
    if (newMode !== null) {
      onToggle(newMode);
    }
  };

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={handleChange}
      size="small"
      sx={{
        bgcolor: 'background.paper',
        '& .MuiToggleButton-root': {
          px: 1.5
        }
      }}
    >
      <ToggleButton value="card" aria-label="Card view">
        <Tooltip title="Card View">
          <GridView fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="list" aria-label="List view">
        <Tooltip title="List View">
          <ViewList fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewToggle;
